module.exports = __webpack_public_path__ + "img/img_zheng@2x.03dedcaa.png";